import { motion } from 'framer-motion';
import React, { FC, useState } from 'react';
import { buttonFadeIn } from '../../animations/fadeIn';
import './_styles.button.css';

interface ButtonProps {
  type?: 'primary' | 'secondary';
  children: React.ReactNode;
  onClick: () => void;
  delay?: number;
  loading?: boolean;
  disabled?: boolean;
}

const Button: FC<ButtonProps> = ({
  type = 'primary',
  children,
  onClick,
  delay = 0,
  loading = false,
  disabled = false,
}) => {
  const [isTimedOut, setIsTimedOut] = useState(false);

  const onButtonClick = () => {
    if (isTimedOut) {
      return;
    }

    onClick();

    setIsTimedOut(true);

    setTimeout(() => {
      setIsTimedOut(false);
    }, 1000);
  };

  return (
    <motion.button
      onClick={disabled || loading ? () => {} : onButtonClick}
      className={`button ${type}`}
      variants={buttonFadeIn(delay)}
      initial='hidden'
      animate='enter'
      exit='exit'
      disabled={disabled}
    >
      <div
        className={`transition-all ${
          loading
            ? 'scale-100 max-w-max opacity-100'
            : 'scale-0 max-w-0 opacity-0'
        }`}
      >
        <svg
          className={`animate-spin -ml-1 mr-3 h-5 w-5 ${
            type === 'primary' ? 'text-white' : 'text-primary'
          }`}
          xmlns='http://www.w3.org/2000/svg'
          fill='none'
          viewBox='0 0 24 24'
        >
          <circle
            className='opacity-25'
            cx='12'
            cy='12'
            r='10'
            stroke='currentColor'
            strokeWidth='4'
          ></circle>
          <path
            className='opacity-75'
            fill='currentColor'
            d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
          ></path>
        </svg>
      </div>
      {children}
    </motion.button>
  );
};

export default Button;
